import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Login from "./Components/Login/Login";
import PageNotFound from "../src/Components/PageNotFound/PageNotFound";
// Dashboard

import Dashboard from "./Components/DashBoard/DashBoard";
import Sidebar from "./Components/Sidebar/Sidebar";
import Header from "./Components/Header/Header";
import AdvanceDashboard from "./Components/DashBoard/AdvanceDashboard/AdvanceDashboard2";

import { Context } from "./utils/context";
import { IDS } from "./utils/common";
import SettingContent from "./Components/Masters/SettingContent/SettingContent";
// import CupponCodes from "./Components/Masters/CupponCodes/Tables";

import SellerDetails from "./Components/sellerDetails/Table";

import Role from "./Components/EmployeeManagement/Role/Table";
import EmployeeDetails from "./Components/EmployeeManagement/EmployeeDetails/Table";
import EmployeeRequest from "./Components/EmployeeManagement/EmployeeRequests/Table";
import EmployeeRejected from "./Components/EmployeeManagement/EmployeeRejected/Table";
import CustomerDetails from "./Components/EmployeeManagement/CustomerDetails/Table";

import FraudUsers from "./Components/EmployeeManagement/FraudUsers/Table";

import ContactUs from "./Components/CustomerManagement/ContactUSList/Tables";
import AttachYourTaxi from "./Components/CustomerManagement/AttachYourTaxi/Table";
import PackageBook from "./Components/CustomerManagement/PackageBook/Tables";

import Booking from "./Components/Booking/Table";

import BookingApp from "./Components/BookingApp/Table";
import BookingRequest from "./Components/BookingRequest/Table";
import BookingRejected from "./Components/BookingRejected/Table";
import Bookingcancelled from "./Components/BookingCancel/Table";
import Specifications from "./Components/AboutUs/Specifications/Tables";
import OurMission from "./Components/AboutUs/OurMission/Tables";
import SocialMedia from "./Components/AboutUs/SocialMedia/Tables";

import WhyChoose from "./Components/AboutUs/why_choose/Tables";
import AboutUs from "./Components/AboutUs/AboutUs/Table";
import OurTeam from "./Components/AboutUs/OurTeam/Table";

import Demo from "./Components/AboutUs/Demo/Tables";

// import ContactSupport from "./Components/Masters/ContactSupport/Tables";
import FuelType from "./Components/Masters/FuelType/Tables";
import SeatCapacity from "./Components/Masters/SeatCapacity/Tables";

import Driver from "./Components/Masters/Driver/Table";

import Vehicle from "./Components/Masters/Vehicle/Table";

// Settings
// Categories
import Category from "./Components/Masters/Category/Tables";
import SubCategory from "./Components/Masters/Sub_Category/Tables";
import ChildSubCategory from "./Components/Masters/Child_Sub_Category/Tables";

// Why
import WhyChooseUs from "./Components/Why/WhyChooseUs/Tables";
import WhyFNS from "./Components/Why/WhyFNS/Tables";

//packages
import Packages from "./Components/Packages/Table";
// Home
import WebHeader from "./Components/Masters/WebHeader/Tables";
import AppSetup from "./Components/Masters/AppSetup/Tables";
import WhyRide from "./Components/Masters/WhyRide/Tables";
import HomeAdBanner from "./Components/Masters/Ad_Banner/Tables";
import AttachYouTaxi from "./Components/Masters/AttachYouTaxi/Tables";
import KeyServices from "./Components/Masters/KeyServices/Tables";

import FaqCategory from "./Components/Masters/FaqCategory/Tables";
import Faq from "./Components/Masters/FAQs/Tables";

//help
import BlogCategory from "./Components/Masters/BlogCategory/Tables";
import Blog from "./Components/Masters/Blog/Tables";

import CategoryRoute from "./Components/Masters/CategoryRoute/Tables";
import SubCategoryRoute from "./Components/Masters/SubCategoryRoute/Tables";

import CabType from "./Components/Masters/CabType/Tables";
import CabCategory from "./Components/Masters/CabCategory/Tables";
import Cabs from "./Components/Masters/Cabs/Tables";
import CabFare from "./Components/Masters/CabFare/Tables";

import LocalPackages from "./Components/Masters/LocalPackages/Tables";

import AddOn from "./Components/Masters/AddOn/Table";
import Additional_Support from "./Components/Masters/Additional_Support/Table";
import HappyCustomer from "./Components/Masters/HappyCustomer/Table";

import Banner from "./Components/Masters/Banner/Tables";

import CouponCodes from "./Components/Masters/CouponCodes/Table";
import BookingCancel from "./Components/Masters/BookingCancel/Table";
// Location
import CountryCode from "./Components/Masters/CountryCode/Tables";
import Country from "./Components/Masters/Country/Tables";
import State from "./Components/Masters/State/Tables";
import City from "./Components/Masters/City/Tables";
import Pincode from "./Components/Masters/Pincode/Tables";
import Area from "./Components/Masters/Area/Tables";

//Content
import Privacy from "./Components/Content/Privacy/Tables";
import Terms from "./Components/Content/Terms/Tables";
import Disclaimer from "./Components/Content/Disclaimer/Tables";
import CanellationPolicy from "./Components/Content/CanellationPolicy/Tables";
import ContactSupport from "./Components/Content/ContactSupport/Tables";
// Specials
import Specials from "./Components/Masters/Specials/Table";

import Subscription from "./Components/Masters/subscription/Tables";
import SubscriptionHistory from "./Components/Masters/SubscriptionHistory/Table";

import WalletHistory from "./Components/Wallet/Table";
import WithdrawlRequest from "./Components/WithdrawlRequest/Tables";

import ReasonsCancellation from "./Components/Masters/ReasonsCancellation/Tables";

import CancellationCharges from "./Components/Masters/CancellationCharges/Edit";

import Employee from "./Components/Masters/Employee/Tables";



import Testimonial from "./Components/Masters/Testimonial/Tables";
import EnquireForm from "./Components/CustomerManagement/EnquireForm/Tables";
import Location from "./Components/Masters/Location/Tables";
import LocationADD from "./Components/Masters/Location/Add";
import LocationEDIT from "./Components/Masters/Location/Edit";

// import Passengers from "./Components/Masters/Passengers/Tables";
const App = () => {
  const location = useLocation();
  const { isSidebarOpen, isAllow } = useContext(Context);
  const [headerText, setHeaderText] = useState(location.pathname);

  const isLoginPage = location.pathname === "/";

  console.log(isAllow, "isAllow");

  useEffect(() => {
    setHeaderText(location.pathname);
  });

  const [urls, setUrls] = useState([]);
  useEffect(() => {
    setUrls([
      {
        path: "/",
        element: <Login />,
        status: true,
      },
      {
        path: "/Header",
        element: <Header />,
        status: true,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
        status: true,
      },
      {
        path: "/advanceDashboard",
        element: <AdvanceDashboard />,
        status: true,
      },
      {
        path: "/settingContent",
        element: <SettingContent />,
        status: true,
      },
      // {
      //   path: "/employee/role",
      //   element: <Role />,
      //   status: isAllow?.includes(IDS.Role.List),
      // },
      {
        path: "/employee/employee-details",
        element: <EmployeeDetails />,
        status: isAllow?.includes(IDS.User.List),
      },
      {
        path: "/employee/employee-requests",
        element: <EmployeeRequest />,
        status: isAllow?.includes(IDS.User.List),
      },
      {
        path: "/employee/employee-rejected",
        element: <EmployeeRejected />,
        status: isAllow?.includes(IDS.User.List),
      },
      {
        path: "/employee/customer-details",
        element: <CustomerDetails />,
        status: isAllow?.includes(IDS.CustomerDetails.List),
      },
      {
        path: "/employee/contact-us",
        element: <ContactUs />,
        status: isAllow?.includes(IDS.ContactUs.List),
      },
      {
        path: "/employee/enquire",
        element: <EnquireForm />,
        status: isAllow?.includes(IDS.ContactUs.List),
      },
      {
        path: "/employee/testimonial",
        element: <Testimonial />,
        status: isAllow?.includes(IDS.ContactUs.List),
      },
      // {
      //   path: "/employee/package-book",
      //   element: <PackageBook />,
      //   status: isAllow?.includes(IDS.ContactUs.List),
      // },
      // {
      //   path: "/employee/attach-your-taxi",
      //   element: <AttachYourTaxi />,
      //   status: isAllow?.includes(IDS.Enquiry.List),
      // },

      {
        path: "/packages",
        element: <Packages />,
        status: isAllow?.includes(IDS.Packages.List),
      },
      // {
      //   path: "/local-packages",
      //   element: <LocalPackages />,
      //   status: isAllow?.includes(IDS.LocalPackages.List),
      // },

      // {
      //   path: "/about-us/specifications",
      //   element: <Specifications />,
      //   status: true,
      // },
      // {
      //   path: "/about-us/our-mission",
      //   element: <OurMission />,
      //   status: isAllow?.includes(IDS.OurVissionMission.List),
      // },
      {
        path: "/about-us/social-media",
        element: <SocialMedia />,
        status: isAllow?.includes(IDS.SocialMedia.List),
      },
      {
        path: "/about-us/why-choose",
        element: <WhyChoose />,
        status: isAllow?.includes(IDS.WhyChoose.List),
      },
      {
        path: "/about-us/about-us-main",
        element: <AboutUs />,
        status: isAllow?.includes(IDS.HomeAboutUs.List),
      },
      // {
      //   path: "/about-us/our-team",
      //   element: <OurTeam />,
      //   status: isAllow?.includes(IDS.OurTeam.List),
      // },
      {
        path: "/content/privacy",
        element: <Privacy />,
        status: isAllow?.includes(IDS.PrivacyPolicy.List),
      },
      // {
      //   path: "/content/disclaimer",
      //   element: <Disclaimer />,
      //   status: isAllow?.includes(IDS.disclaimer.List),
      // },
      {
        path: "/content/cancellation-policy",
        element: <CanellationPolicy />,
        status: isAllow?.includes(IDS.cancellation_policy.List),
      },
      {
        path: "/content/terms",
        element: <Terms />,
        status: isAllow?.includes(IDS.TermsConditions.List),
      },
      {
        path: "/content/contact-support",
        element: <ContactSupport />,
        status: isAllow?.includes(IDS.ContactSupport.List),
      },
      // {
      //   path: "/settings/category",
      //   element: <Category />,
      //   status: isAllow?.includes(IDS.Category.List),
      // },
      // {
      //   path: "/settings/sub-category",
      //   element: <SubCategory />,
      //   status: isAllow?.includes(IDS.SubCategory.List),
      // },
      // {
      //   path: "/settings/child-sub-category",
      //   element: <ChildSubCategory />,
      //   status: true,
      // },
      // {
      //   path: "/settings/add-on",
      //   element: <AddOn />,
      //   status: isAllow?.includes(IDS.AddOn.List),
      // },

      // {
      //   path: "/settings/additional-support",
      //   element: <Additional_Support />,
      //   status: isAllow?.includes(IDS.AdditionalSupport.List),
      // },
      // {
      //   path: "/why/why-choose-us",
      //   element: <WhyChooseUs />,
      //   status: isAllow?.includes(IDS.WhyFNS.List),
      // },
      {
        path: "why/why-fns",
        element: <WhyFNS />,
        status: isAllow?.includes(IDS.WhyFNS.List),
      },
      // {
      //   path: "/settings/customization/web-header",
      //   element: <WebHeader />,
      //   status: true,
      // },
      {
        path: "/settings/customization/app-setup",
        element: <AppSetup />,
        status: isAllow?.includes(IDS.AppSetup.List),
      },

      // {
      //   path: "/home/attach-your-taxi",
      //   element: <AttachYouTaxi />,
      //   status: true,
      // },
      // {
      //   path: "/home/key-services",
      //   element: <KeyServices />,
      //   status: isAllow?.includes(IDS.key_services.List),
      // },
      // {
      //   path: "/home/happy-customer",
      //   element: <HappyCustomer />,
      //   status: isAllow?.includes(IDS.happy_customer.List),
      // },
      // {
      //   path: "/settings/customization/home-ad-banner",
      //   element: <HomeAdBanner />,
      //   status: true,
      // },
      // {
      //   path: "/home/why-ride",
      //   element: <WhyRide />,
      //   status: true,
      // },
      {
        path: "/settings/customization/banner",
        element: <Banner />,
        status: true,
      },
      // {
      //   path: "/settings/customization/faq-category",
      //   element: <FaqCategory />,
      //   status: isAllow?.includes(IDS.SocialMedia.List),
      // },
      {
        path: "/settings/customization/faqs",
        element: <Faq />,
        status: isAllow?.includes(IDS.FAQList.List),
      },
      // {
      //   path: "/settings/blog-category",
      //   element: <BlogCategory />,
      //   status: isAllow?.includes(IDS.blog_category.List),
      // },
      {
        path: "/settings/blogs",
        element: <Blog />,
        status: isAllow?.includes(IDS.blog.List),
      },

      {
        path: "/settings/cab-type",
        element: <CabType />,
        status: isAllow?.includes(IDS.cab_type.List),
      },
      {
        path: "/settings/cab-category",
        element: <CabCategory />,
        status: isAllow?.includes(IDS.cab_type.List),
      },
      // {
      //   path: "/settings/cabs",
      //   element: <Cabs />,
      //   status: true,
      // },
      // {
      //   path: "/settings/cab-fare",
      //   element: <CabFare />,
      //   status: isAllow?.includes(IDS.cab_fare.List),
      // },
      // {
      //   path: "/settings/Coupon-codes",
      //   element: <CouponCodes />,
      //   status: isAllow?.includes(IDS.cuppon_codes.List),
      // },
      {
        path: "/settings/location/country-code",
        element: <CountryCode />,
        status: isAllow?.includes(IDS.CountryCode.List),
      },
      {
        path: "/settings/location/country",
        element: <Country />,
        status: isAllow?.includes(IDS.Country.List),
      },
      {
        path: "/settings/location/state",
        element: <State />,
        status: isAllow?.includes(IDS.State.List),
      },
      {
        path: "/settings/location/city",
        element: <City />,
        status: isAllow?.includes(IDS.City.List),
      },
      {
        path: "/settings/location/pincode",
        element: <Pincode />,
        status: isAllow?.includes(IDS.Pincode.List),
      },
      // {
      //   path: "/settings/location/area",
      //   element: <Area />,
      //   status: isAllow?.includes(IDS.Pincode.List),
      // },
      // {
      //   path: "/settings/specials",
      //   element: <Specials />,
      //   status: isAllow?.includes(IDS.Special.List),
      // },
      {
        path: "/bookings",
        element: <Booking />,
        status: isAllow?.includes(IDS.Booking.List),
      },

      // {
      //   path: "/app-bookings",
      //   element: <BookingApp />,
      //   status: isAllow?.includes(IDS.Booking.List),
      // },
      {
        path: "/booking-rejected",
        element: <BookingRejected />,
        status: isAllow?.includes(IDS.BookingCancel.List),
      },
      {
        path: "/booking-cancelled",
        element: <Bookingcancelled />,
        status: isAllow?.includes(IDS.BookingCancel.List),
      },
      // {
      //   path: "/booking-request",
      //   element: <BookingRequest />,
      //   status: isAllow?.includes(IDS.BookingRequest.List),
      // },
      // {
      //   path: "/booking-rejected",
      //   element: <BookingRejected />,
      //   status: isAllow?.includes(IDS.BookingRejected.List),
      // },
      // {
      //   path: "/wallet-history",
      //   element: <WalletHistory />,
      //   status: isAllow?.includes(IDS.walleteHistory.List),
      // },

      // {
      //   path: "/category-route",
      //   element: <CategoryRoute />,
      //   status: isAllow?.includes(IDS.categories_route.List),
      // },
      // {
      //   path: "/sub-category-route",
      //   element: <SubCategoryRoute />,
      //   status: isAllow?.includes(IDS.sub_category_route.List),
      // },
      {
        path: "/location",
        element: <Location />,
        status: isAllow?.includes(IDS.categories_route.List),
      },
      {
        path: "/location/add",
        element: <LocationADD />,
        status: isAllow?.includes(IDS.categories_route.List),
      },
      {
        path: "/location/edit/:id",
        element: <LocationEDIT />,
        status: isAllow?.includes(IDS.categories_route.List),
      },
      // {
      //   path: "/about-us/demo",
      //   element: <Demo />,
      //   status: true,
      // },
      {
        path: "/settings/customization/contact-support",
        element: <ContactSupport />,
        status: isAllow?.includes(IDS.FAQList.List),
      },
      {
        path: "/settings/customization/fuel-type",
        element: <FuelType />,
        status: isAllow?.includes(IDS.fuel_type.List),
      },
      {
        path: "/settings/customization/seat-capacity",
        element: <SeatCapacity />,
        status: isAllow?.includes(IDS.seat_capacity.List),
      },
      {
        path: "/settings/customization/driver",
        element: <Driver />,
        status: isAllow?.includes(IDS.driver.List),
      },
      // {
      //   path: "/settings/customization/vehicle",
      //   element: <Vehicle />,
      //   status: isAllow?.includes(IDS.Vehicle.List),
      // },
      {
        path: "/settings/customization/subscriptions",
        element: <Subscription />,
        status: isAllow?.includes(IDS.subscription.List),
      },
      {
        path: "/settings/customization/subscription_history",
        element: <SubscriptionHistory />,
        status: isAllow?.includes(IDS.subscription_history.List),
      },
      {
        path: "/employee/fraud-user",
        element: <FraudUsers />,
        status: isAllow?.includes(IDS.FraudUser.List),
      },
      {
        path: "/master/reasons-cancellation",
        element: <ReasonsCancellation />,
        status: isAllow?.includes(IDS.reasons_cancellation.List),
      },
      // {
      //   path: "/master/cancellation-charges",
      //   element: <CancellationCharges />,
      //   status: isAllow?.includes(IDS.cancellation_charages.List),
      // },
      {
        path: "/employee",
        element: <Employee />,
        status: isAllow?.includes(IDS.employee.List),
      },

      // {
      //   path: "/wallet-history",
      //   element: <WalletHistory />,
      //   status: isAllow?.includes(IDS.employee.List),
      // },

      {
        path: "/withdrawl-request",
        element: <WithdrawlRequest />,
        status: isAllow?.includes(IDS.employee.List),
      },


      // {
      //   path: "/master/passengers",
      //   element: <Passengers />,
      //   status: isAllow?.includes(IDS.cancellation_policy.List),
      // },
    ]);
  }, [isAllow]);

  return (
    <div
      className={`main ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
    >
      {isLoginPage ? (
        <Login />
      ) : (
        <div className="row sidebar-x-scroll">
          <div
            className={`pe-0 ${isSidebarOpen
              ? "sidebarHeadopen col-2"
              : "scale-in-hor-left sidebarHeadClose col-1"
              }`}
          >
            <Sidebar />
          </div>

          <div
            className={`ps-0 ${isSidebarOpen
              ? "dashboardOpen col-10"
              : "scale-in-hor-right dashboardOpen col-11"
              }`}
          >
            <div className="allRoutesMain">
              <Routes>
                {urls?.map(
                  (url) =>
                    url.status && (
                      <Route
                        key={url.path}
                        path={url.path}
                        element={url.element}
                      />
                    )
                )}
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
